import { Country, UserRole } from '@enmon/commons/lib/enmon';

export const PREFIX = 'app/App/' as const;

export const CONFLICT_ERROR = `${PREFIX}CONFLICT_ERROR` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const FETCHING_DATA_FAILED = `${PREFIX}FETCHING_DATA_FAILED` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const ACTION_FAILED = `${PREFIX}ACTION_FAILED` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const CREATE_EMISSION_FACTOR_SUCCESS = `${PREFIX}CREATE_EMISSION_FACTOR_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const CREATE_EMISSION_FACTOR_ERROR = `${PREFIX}CREATE_EMISSION_FACTOR_ERROR` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const DELETE_EMISSION_FACTOR_SUCCESS = `${PREFIX}DELETE_EMISSION_FACTOR_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const DELETE_EMISSION_FACTOR_ERROR = `${PREFIX}DELETE_EMISSION_FACTOR_ERROR` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const EDIT_EMISSION_FACTOR_SUCCESS = `${PREFIX}EDIT_EMISSION_FACTOR_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const EDIT_EMISSION_FACTOR_ERROR = `${PREFIX}EDIT_EMISSION_FACTOR_ERROR` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const CREATE_EMISSION_RECORD_SUCCESS = `${PREFIX}CREATE_EMISSION_RECORD_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const CREATE_EMISSION_RECORD_ERROR = `${PREFIX}CREATE_EMISSION_RECORD_ERROR` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const UPDATE_EMISSION_RECORD_SUCCESS = `${PREFIX}UPDATE_EMISSION_RECORD_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const UPDATE_EMISSION_RECORD_ERROR = `${PREFIX}UPDATE_EMISSION_RECORD_ERROR` as const;

/** @deprecated Use `createAction(...).type` instead. */
export const DELETE_EMISSION_RECORD_SUCCESS = `${PREFIX}DELETE_EMISSION_RECORD_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const DELETE_EMISSION_RECORD_ERROR = `${PREFIX}DELETE_EMISSION_RECORD_ERROR` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const CREATE_SUPPLY_POINT_SUCCESS = `${PREFIX}CREATE_SUPPLY_POINT_SUCCESS` as const;
/** @deprecated Use `createAction(...).type` instead. */
export const CREATE_SUPPLY_POINT_ERROR = `${PREFIX}CREATE_SUPPLY_POINT_ERROR` as const;

export const INTERNAL_USER_ROLES = [UserRole.Demo, UserRole.Tools, UserRole.Meters] as const;

export const COUNTRIES_WITHOUT_THIRD_PARTY_DATA = [Country.PL] as const;

export const CONSENT_IS_POSTPONED_KEY = 'consentIsPosponed' as const;
